import React from 'react'
import { IconCheckbox } from '@tabler/icons-react'
import Typography from '../atoms/Typography'

interface ProjectSelectionBarProps {
  selectedCount: number
  totalCount: number
  onSelectAll: () => void
  onDeselectAll: () => void
}

export const ProjectSelectionBar: React.FC<ProjectSelectionBarProps> = ({
  selectedCount,
  totalCount,
  onSelectAll,
  onDeselectAll,
}) => {
  const hasSelection = selectedCount > 0

  return (
    <div className="flex items-center justify-between px-7 py-2">
      <button
        onClick={hasSelection ? onDeselectAll : onSelectAll}
        className="flex items-center gap-2 pl-4 pr-2 py-2 text-light-green-500 transition-colors hover:text-light-green-400"
      >
        <IconCheckbox className="h-6 w-6" />
        <Typography variant="sm-medium" className="text-light-green-500">
          {hasSelection ? 'Deselect all' : 'Select all'}
        </Typography>
      </button>
      <Typography variant="sm" className="text-gray-50">
        {totalCount} {totalCount === 1 ? 'Total Project' : 'Total Projects'}
      </Typography>
    </div>
  )
}
